import $ from 'jquery';

export function initSlider(jsSlider) {
    $(document).ready(function () {
        $(jsSlider).slick({
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300
        });
    });
}
